var styleDataHash = "fe2ed1b4";
const injectCss = () => {
  var css = `._2P4ff{display:flex}[dir] ._2P4ff{margin:0}.Usj1k{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff));font-size:inherit;font-weight:inherit;line-height:28px;max-width:270px;overflow:hidden;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}[dir] .Usj1k{margin:0;padding:0 4px}.Usj1k:hover{text-decoration:underline}.Usj1k:focus{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}.Usj1k.vrwAy{line-height:32px}[dir] ._5OEfL{background:transparent;border:0}[dir] ._5OEfL:hover{cursor:pointer}@supports not (contain:inline-size){@media only screen and (max-width:640px){.Usj1k{max-width:160px}}}@container (width < 640px){.Usj1k{max-width:160px}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var url_link_button_default = {
  "toolbarUrlContainer": "_2P4ff",
  "toolbarUrl": "Usj1k",
  "isMobile": "vrwAy",
  "toolbarUrlAnchor": "_5OEfL"
};
export {
  url_link_button_default as default,
  injectCss
};
//# sourceMappingURL=url-link-button-scss.js.map
